import { render, staticRenderFns } from "./institutions.vue?vue&type=template&id=ea85f634&scoped=true"
import script from "./institutions.vue?vue&type=script&lang=js"
export * from "./institutions.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/custom.scss?vue&type=style&index=0&id=ea85f634&prod&lang=scss&scoped=true&external"
import style1 from "./institutions.vue?vue&type=style&index=1&id=ea85f634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea85f634",
  null
  
)

export default component.exports